// The end-of-session survey answer, in the words the student read.
//
// The backend sends the raw enum the student picked (`NEED_HELP` | `OK` |
// `GREAT`) on the session row. The report shows the same sentence the student
// was shown when they answered, so the copy is read from the options the survey
// itself renders rather than transcribed a second time.

import { SESSION_SURVEY_OPTIONS } from "./general";

/**
 * The student-facing label for a survey rating.
 *
 * @param {string|null|undefined} rating The raw enum from the session row.
 * @returns {string|null} The label, or null for a rating this build does not
 *   know — callers fall through to whatever they had rather than showing a
 *   teacher a raw token like "NEED_HELP".
 */
export const sessionSurveyLabel = (rating) => {
  const option = SESSION_SURVEY_OPTIONS.find((each) => each.value === rating);
  return option ? option.label : null;
};
